import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function PdfFormErrorIndicator({ on = false, onClick }) {
  return (
    <div
      className={"is-clickable is-pulled-right has-text-danger " + (on ? "" : "is-invisible")}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faExclamationCircle} />
    </div>
  );
}

export default PdfFormErrorIndicator;
